module.exports = __webpack_public_path__ + "img/calculator.64069283.png";